import { Injectable, Input } from '@angular/core';
import { Dimension } from './solucion/Dimension.entity';
import { Etapa, DiagnosticoCliente } from './diagnostico/Diagnostico.entity';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras } from '@angular/router';
import { CuestionarioHttpServicesService } from './cuestionario-http-services.service';
import { User } from './shared/user.model';
import { UserService } from './shared/user.service';
import { Respuesta } from './cuestionario/cuestionario.entity';

export class RecursosSeccion {
  show: Boolean;
}

export class PresentacionOk {
  ok: Boolean;
}

@Injectable()
export class NavegacionService {

  public repuestasParaFormularioCompleto = 40;
  public storage: any;
  public buscandoEtapa = false;
  // public mostrarRecursos: RecursosSeccion;
  // public presentacion: PresentacionOk;
  _currentClient: User;
  get currentClient(): User {
    if (!this._currentClient) {
      // console.log('Busco el cliente info.');
      const client = JSON.parse(sessionStorage.getItem('currClient')) ;
      // console.log('Cliente:');
      // console.log(client);
      if (client === null) {
        this.userService.getUserClaims().subscribe((data: any) => {
          this._currentClient = data;
          sessionStorage.setItem('currClient', JSON.stringify(data) );
        });
      } else {
        this._currentClient = client;
      }
      // this._cuestionarioServices.getCliente().subscribe( objarray => {
      //        if (objarray !== undefined) {
      //         console.log('Recuperando cliente:' , objarray);
      //         this._currentClient = objarray[0];
      //        }
      //   });
    }
    return this._currentClient;
  }
  @Input('currentClient')
  set currentClient(value: User) {
      this._currentClient = value;
      if (value === null) {
          sessionStorage.removeItem('currClient');
    }
  }

  _currentDiag: DiagnosticoCliente;
  get currentDiag(): DiagnosticoCliente {
    if (this._currentDiag === undefined) {
      // console.log('Busco el cliente info.');
      const diag = JSON.parse(sessionStorage.getItem('currentDiag')) ;
      // console.log('Cliente:');
      // console.log(client);
      if (diag === null) {
        this.irDdashboardDiagnostico();
      } else {
        this._currentDiag = diag;
      }
    }
    return this._currentDiag;
  }
  @Input('currentDiag')
  set currentDiag(value: DiagnosticoCliente) {
      sessionStorage.setItem('currentDiag', JSON.stringify(value) );
      // sessionStorage.setItem('currentDiag', value.toString());
      this._currentDiag = value;
  }
  _currentEtapa: Etapa;
  get currentEtapa(): Etapa {
    if (this._currentEtapa === undefined) {
      if (this._etapas === undefined) {
        this._cuestionarioServices.getDimension().subscribe( objarray => {
        this._cuestionarioServices.getEtapa().subscribe( objEtapa => {
          // alert('En el constuctor de sidenav');
          // console.log('En sidenav:' , this.currentClient);
          this._etapas = objEtapa;
          this._dimensiones = objarray;
          return this._etapas[0];
        });
      });
    } else {
      const etapa = JSON.parse(sessionStorage.getItem('currentEtapa')) ;
      if (etapa === null) {
          let etapas: Etapa[];
          if (!this.buscandoEtapa) {
            this.buscandoEtapa = true;
          console.log('Buscando current etapa.');
          this._cuestionarioServices.getCurrentEtapa(this.currentDiag.diagnosticoID).subscribe( objs => {
            etapas = objs;
          if ( etapas.length === 1) {
            console.log(etapas);
            sessionStorage.setItem('currentEtapa', JSON.stringify(etapas[0]) );
            this._currentEtapa = etapas[0];
            this.buscandoEtapa = false;
            return etapas[0];
          }
          });
        }
     } else {
        return etapa;
     }
     // return this._etapas[0];
    }}
    return this._currentEtapa;
  }
  @Input('currentEtapa')
  set currentEtapa(value: Etapa) {
      sessionStorage.setItem('currentEtapa', JSON.stringify(value) );
      this._currentEtapa = value;
  }
  public currentDimension: Dimension;
  // public currentCapa: Capa;
  public _dimensiones: Dimension[];
  public _etapas: Etapa[];
  constructor(
      private userService: UserService,
      private _cuestionarioServices: CuestionarioHttpServicesService, // PD
      private _router: Router) {
        // this.currentClient = null;
        this._cuestionarioServices.getDimension().subscribe( objarray => {
          this._cuestionarioServices.getEtapa().subscribe( objEtapa => {
            // alert('En el constuctor de sidenav');
            // console.log('En el contrusctor de sidenav:' , this.currentClient);
            this._etapas = objEtapa;
            this._dimensiones = objarray;
            // this.presentacion = new PresentacionOk();
            // this.presentacion.ok = false;
          });
        });
      }

  // /**
  //  * Setter for sidenav.
  //  *
  //  * @param {MdSidenav} sidenav
  //  */
  // public setSidenav(sidenav: MatSidenav) {
  //   this.sidenav = sidenav;
  // }

  /* public setmostrarRecursos( _mostarRecursos: RecursosSeccion ) {
    // alert('Al setear');
    // alert(_mostarRecursos.show);
    this.mostrarRecursos = _mostarRecursos;
    // this.mostrarRecursos.show = false;
    // alert(_mostarRecursos.show);
    // alert(this.mostrarRecursos.show);
    // alert('Fin setear');
  } */
 /*  public recursos(mostrar: Boolean) {
    // alert(mostrar);
    this.mostrarRecursos.show = mostrar;
   }

  public presentacionok(ok: boolean) {
    this.presentacion.ok = ok;
  }
  public setpresentacion(_presentacion: PresentacionOk) {
    // alert(mostrar);
    this.presentacion = _presentacion;
   } */

   backClicked() {
     // console.log(this.currentEtapa.etapaId);
    switch (this.currentEtapa.etapaId) {
      case 1:
        this.irDiagnostico();
      break;
      case 2: // Estado de tu organizacion
        this.setEtapabyId(1);
      break;
      case 3: // Cambios de -> hacia // Estado de tu organizacion
        this.setEtapabyId(1);
      break;
      case 4: // Situacion Actual
        this.setEtapabyId(3);
      break;
     /*  case 5: // Desconexiones
        this.setEtapabyId(4);
      break;
     Soluciones no hay
      case 5:
        this.setEtapabyId(4);
      break;
      */
    }
   }

 public Iniciar() {
  // this._sidenav.toggle();
  // this.recursos(false);
  this._router.navigate(['/cuestionario']);
}
public irDdashboard() {
  this._router.navigate(['/dashboard']);
}
public irDdashboardDiagnostico() {
  this._router.navigate(['/dashboard-Diagnostico']);
}
public irDiagnostico() {
  // if (this.currentDiag) {
    this._router.navigate(['/dashboard-Diagnostico']);
  // }
}
public irFin(htmldoc: any) {
  // console.log('en nav ', htmldoc);
  this.storage = htmldoc;
  this._router.navigate(['/congrats']);
}
public irSolucion() {
  // this._sidenav.toggle();
  // this.recursos(false);
  let respuestas: Respuesta[];
  this._cuestionarioServices.getRespuestas(this.currentDiag.diagnosticoID).subscribe( objs => {
    respuestas = objs;
    if ( respuestas.length > this.repuestasParaFormularioCompleto ) {
      this._router.navigate(['/soluciones']);
    }
  });
}
public irCuestionario(etapa: string) {
  // this._sidenav.toggle();
  //  this.recursos(false);
  // this.setEtapabyId(3);
  this.setEtapabyId(3);
  // alert('En ir a cuestionario');
}
public irDesconexiones() {
  this.setEtapabyId(3);
  // this._router.navigate(['/cuestionario']);
}

atrasEtapa(): void {
  let ind = 0;
  ind = this._etapas.findIndex(item => item.etapaId === this.currentEtapa.etapaId);
  // console.log('Indice ant ', ind);
  if (this.currentEtapa.hasChild) {
    let index = this._dimensiones.findIndex(item => item.dimensionID === this.currentDimension.dimensionID);
    if (index < 0) {
         --index;
         this.currentDimension = this._dimensiones[index];
         this.setDimension(this.currentDimension.descripcion);
    } else {
      --ind;
    }
  } else {
   --ind;
  }
  // console.log('Indice ', ind);
  if (ind <= 0 ) {
          this.currentEtapa = this._etapas[ind];
          if (this.currentEtapa.etapaId === 4 || this.currentEtapa.etapaId === 5 ) {
            this.irSolucion();
           }
    }
    // console.log('Current ', this.currentEtapa.descripcion);
 }
setEtapa(etapaSeleccion?: string): void {

  if (etapaSeleccion !== undefined) {
  // console.log('Por etapa seleccion', etapaSeleccion);
  if (this.currentEtapa !== undefined) {
   this.cambiarEtapa(etapaSeleccion);
   this.setDimension();
  }
  } else {
  if (this.currentEtapa.hasChild) {
   if (!this.setDimension()) {
     // console.log('Por etapa seleccion tiene hijo');
     this.cambiarEtapa();
   }
 } else {
    // console.log('Por etapa seleccion No tiene hijo');
   this.cambiarEtapa();
   this.setDimension();
 }
}
// alert('');
}

buscarEtapaDiagnostico() {
  let etapas: Etapa[];
  console.log('Buscando current etapa.');
  this._cuestionarioServices.getCurrentEtapa(this.currentDiag.diagnosticoID).subscribe( objs => {
    etapas = objs;
   if ( etapas.length === 1) {
    console.log(etapas);
    this.currentEtapa = etapas[0];
    this.setEtapabyId(etapas[0].etapaId);
    }
  });
}

setEtapabyId(etapaSeleccion?: number): void {
  if (etapaSeleccion !== undefined) {
  // console.log('Por etapa seleccion', etapaSeleccion);
    if (this.currentEtapa !== undefined) {
        this.cambiarEtapabyId(etapaSeleccion);
        this.setDimension();
    }
  } else {
  if (this.currentEtapa.hasChild) {
   if (!this.setDimension()) {
     // console.log('Por etapa seleccion tiene hijo');
     this.cambiarEtapa();
   }
 } else {
    // console.log('Por etapa seleccion No tiene hijo');
   this.cambiarEtapa();
   this.setDimension();
 }
}
// alert('');
}
cambiarEtapabyId(etapaSeleccion?: number): void {
  let currentEtapa = this.currentEtapa;
  let ind = 0;
  // console.log('En seleccion ', etapaSeleccion);
  if (etapaSeleccion === undefined) {
    ind = this._etapas.findIndex(item => item.etapaId === currentEtapa.etapaId);
    ++ind;
  } else {
  ind = this._etapas.findIndex(item => item.etapaId === etapaSeleccion);
 }
  // console.log('Indice ', ind);
  if (ind < this._etapas.length ) {
          this.currentEtapa = this._etapas[ind];
          currentEtapa =  this._etapas[ind];
           if (currentEtapa.etapaId === 4 || currentEtapa.etapaId === 5 ) {
            this.irSolucion();
           } else {
            //  console.log('Indice ', ind);
            this._router.navigate(['/cuestionario']);
            // this.irCuestionario(currentEtapa.descripcion);
           }
    }
    // console.log('Current ', this.currentEtapa.descripcion);
 }
cambiarEtapa(etapaSeleccion?: string): void {
  let currentEtapa = this.currentEtapa;
 let ind = 0;
 // console.log('En seleccion ', etapaSeleccion);
 if (etapaSeleccion === undefined) {
   ind = this._etapas.findIndex(item => item.etapaId === currentEtapa.etapaId);
   ++ind;
 } else {
 ind = this._etapas.findIndex(item => item.descripcion === etapaSeleccion);
}
 // console.log('Indice ', ind);
 if (ind < this._etapas.length ) {
         this.currentEtapa = this._etapas[ind];
         currentEtapa = this._etapas[ind];
          if (currentEtapa.etapaId === 4 || currentEtapa.etapaId === 5 ) {
           this.irSolucion();
          } else {
           //  console.log('Indice ', ind);
           // if (currentEtapa.etapaId === 3) {
           //   this.setDimension('Liderazgo');
           // }
           this._router.navigate(['/cuestionario']);
           //  this.irCuestionario(currentEtapa.descripcion);
          }
   }
   // console.log('Current ', this.currentEtapa.descripcion);
}
setDimension(seleccion?: string): Boolean {
 let result: Boolean = false;
 // alert(seleccion);
 // alert(this.currentEtapa.hasChild);
 if (this.currentEtapa.hasChild) {
 if (this.currentDimension == null) {
    this.currentDimension = this._dimensiones[0];
    result = true;
  } else {
    let index = 0;
    if (seleccion === undefined) {
      index = this._dimensiones.findIndex(item => item.dimensionID === this.currentDimension.dimensionID);
      ++index;
    } else {
      index = this._dimensiones.findIndex(item => item.descripcion === seleccion);
   }
    if (index < this._dimensiones.length) {
           this.currentDimension = this._dimensiones[index];
           result = true;
      }
   }
 } else { this.currentDimension = null; }
 //   console.log(this.currentDimension);
 return result;
}
  // /**
  //  * Open this sidenav, and return a Promise that will resolve when it's fully opened (or get rejected if it didn't).
  //  *
  //  * @returns Promise<MdSidenavToggleResult>
  //  */
  // public open(): Promise<void> {
  //   return this.sidenav.toggle();
  // }

  // /**
  //  * Close this sidenav, and return a Promise that will resolve when it's fully closed (or get rejected if it didn't).
  //  *
  //  * @returns Promise<MdSidenavToggleResult>
  //  */
  // public close(): Promise<void> {
  //   return this.sidenav.close();
  // }

  // /**
  //  * Toggle this sidenav. This is equivalent to calling open() when it's already opened, or close() when it's closed.
  //  *
  //  * @param {boolean} isOpen  Whether the sidenav should be open.
  //  *
  //  * @returns {Promise<MdSidenavToggleResult>}
  //  */
  // public toggle(isOpen?: boolean): Promise<void> {
  //   return this.sidenav.toggle(isOpen);
  // }
}



// WEBPACK FOOTER //
// ./src/app/sidenav.service.ts